import { WuiBox, WuiButton, WuiLoader, WuiThemeSection } from '@jwplayer/wui-react';
import { Suspense } from 'react';

import { LogoFull } from '/component/svg';
import { Link } from '/module/routing/link';

import css from './style.module.scss';

export function ChromeFullscreen({ children }: { children?: React.ReactNode }) {
  return (
    <WuiThemeSection theme="dark" className={css.fullscreen}>
      <WuiBox orientation="horizontal" align="center" justify="space-between" gutter="md" className={css.nav}>
        <Link to="login" data-test="show-login-page">
          <LogoFull markColor="dahlia" />
        </Link>

        <WuiBox orientation="horizontal" gutter="md">
          <WuiButton
            type="tertiary"
            data-test="link-company-site"
            label="Company"
            as={['a', { href: 'https://www.jwplayer.com/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-developer-site"
            label="Developer"
            as={['a', { href: 'https://developer.jwplayer.com/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-support-site-top"
            label="Support"
            as={['a', { href: 'https://support.jwplayer.com/', target: '_blank' }]}
          />
          <WuiButton
            type="secondary"
            data-test="link-signup-page"
            label="Sign up"
            as={['a', { href: 'https://www.jwplayer.com/sign-up', target: '_blank' }]}
          />
        </WuiBox>
      </WuiBox>

      <div className={css.contentContainer}>
        <Suspense fallback={<WuiLoader size="lg" />}>{children}</Suspense>
      </div>

      <div className={css.footer}>
        <WuiBox marginBottom="lg" orientation="horizontal" gutter="md" justify="center">
          <WuiButton
            type="tertiary"
            data-test="link-support-site-footer"
            label="Support"
            as={['a', { href: 'https://support.jwplayer.com/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-tos-page"
            label="Terms of service"
            as={['a', { href: 'https://www.jwplayer.com/tos/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-privacy-page"
            label="Privacy policy"
            as={['a', { href: 'https://www.jwplayer.com/tos/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-dmca-page"
            label="DMCA"
            as={['a', { href: 'https://www.jwplayer.com/dmca/', target: '_blank' }]}
          />
          <WuiButton
            type="tertiary"
            data-test="link-adchoices-page"
            label="Ad choices"
            as={['a', { href: 'https://www.jwplayer.com/privacy/#ad-choices', target: '_blank' }]}
          />
        </WuiBox>

        <div className={css.copyright}>
          &copy; {new Date().getUTCFullYear()} Longtail Ad Solutions, Inc. All rights reserved. JW Player is a
          registered trademark.
        </div>
      </div>
    </WuiThemeSection>
  );
}
